import Api from 'entities/helpers/api';
import PropTypes from 'prop-types';
import { isEmpty } from '@evertrue/sdk';
import { useEffect, useState } from 'react';
import { Card, Button, Link } from '@evertrue/et-components';

const NUM_LISTS = 4;

/*
  Function for grouping list and featured Lists
  */
const groupLists = (lists) => {
  let listArray = lists.map((seg) => ({
    label: seg.name,
    value: seg.id,
    type: 'saved_search',
  }));

  return listArray;
};

const RecentlyViewedLists = ({ lists = [], onClick }) => {
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    try {
      Api.DNA.SETTING.get({
        urlArgs: { setting_key: 'GT_recent_lists' },
        disableAlerts: true,
        params: { user_id: 'me', oid: null },
      }).then((resp) => {
        // This smells funny -- since we are paginating the lists, the only recently viewed lists that we can show are ones that are already displayed on the table
        const recent = Array.from(new Set(resp?.settings?.GT_recent_lists?.value?.lists));
        const groupedLists = groupLists(lists);
        let ordered;
        if (!isEmpty(recent)) {
          ordered = recent.map((id) => groupedLists.find((item) => item.value === id)).filter(Boolean);
          if (ordered.length < NUM_LISTS) {
            let remaining = groupedLists
              .filter((seg) => !recent.includes(seg.value))
              .sort((a, b) => a.label.localeCompare(b.label))
              .slice(0, NUM_LISTS - ordered.length);
            ordered = ordered.concat(remaining).filter(Boolean);
          }
          setRecentlyViewed(ordered);
        } else {
          setRecentlyViewed(groupedLists.sort((a, b) => a.label.localeCompare(b.label)));
        }
      });
    } catch (error) {
      setRecentlyViewed([]);
    }
  }, [lists]);

  return (
    <Card headingText="Recently Viewed Lists" className="lists-page--recent" padding="16px">
      <div className="lists-page--cardbody">
        {recentlyViewed.map((list) =>
          // If there is an onClick function, render a button, otherwise render a link
          onClick ? (
            <Button
              title={list.label}
              type="simple"
              accessibilityAttributes={{ role: 'link', tabIndex: '0' }}
              className="lists-page--recent-item"
              key={list.value}
              title={list.label}
              onClick={() => onClick(list.value)}
            >
              {list.label}
            </Button>
          ) : (
            <Link title={list.label} className="lists-page--recent-item" key={list.value} href={`list/${list.value}`}>
              {list.label}
            </Link>
          )
        )}
      </div>
    </Card>
  );
};

RecentlyViewedLists.propTypes = {
  lists: PropTypes.array,
  onClick: PropTypes.func,
};

export default RecentlyViewedLists;
